<ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
<ng-template #contentTemplate>
  <div class="d-flex flex-column h-100">
    <div class="offcanvas-header d-flex justify-content-between py-0">
      <h4 class="offcanvas-title">Application : {{ this.selectedApplication.appName }} - {{
        this.selectedApplication.appVersionText }}</h4>
      <button type="button" class="actionBtn" (click)="close()" matTooltip="Close">
        <mat-icon style="color: red;">close</mat-icon>
      </button>
    </div>
    <div class="offcanvas-body flex-grow-1 py-0 pt-1 d-flex flex-column">
      <div class="options">
        <p (click)="openDetails()" [ngClass]="{ active: activeTab === 1 }" [ngbTooltip]="'Details of '+selectedApplication.appName">
          Application Details
        </p>
        @if(!isMonitor){
          <div class="btn-group" ngbDropdown container="body" role="group"
            aria-label="Button group with nested dropdown">
            <button class="default-btn" ngbDropdownToggle>Actions</button>
            <div class="dropdown-menu" ngbDropdownMenu>
              @for (action of actionButtons; track $index) {
                <button ngbDropdownItem [ngbTooltip]="action.label" (click)="emitAction(action.action)">
                  <span class="text-dark" style="font-size: small;">{{ action.label }}</span>
                </button>
              } @empty {
                <button ngbDropdownItem disabled>No actions available</button>
              }
            </div>
          </div>
        }
      </div>
      <div class="childs flex-grow-1">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noContent>
  <p class="pt-5 text-center">Something went wrong!</p>
</ng-template>